import { render, staticRenderFns } from "./DictionaryMngtReg.vue?vue&type=template&id=6b5d3a49"
import script from "./DictionaryMngtReg.vue?vue&type=script&lang=js"
export * from "./DictionaryMngtReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports